import { render, staticRenderFns } from "./ShareInvoiceModal.vue?vue&type=template&id=5f51d736&scoped=true&"
import script from "./ShareInvoiceModal.vue?vue&type=script&lang=js&"
export * from "./ShareInvoiceModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareInvoiceModal.vue?vue&type=style&index=0&id=5f51d736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f51d736",
  null
  
)

export default component.exports